import styled from "styled-components"
import { FlexBox } from "./FlexBox"
import { formatDisplayNumber, roundByDecimalPlace } from "utils"

const DisplayedCalories = styled.div`
  margin: 0;
  font-size: 12px;
  display: flex;

  justify-content: flex-end;
  border-radius: 4px;
  padding-left: var(--spacing_xs, 6px);
  background: var(
    --Gradient,
    linear-gradient(
      90deg,
      rgba(204, 237, 237, 0.72) 10.84%,
      rgba(255, 255, 255, 0) 88.19%
    )
  );
  color: var(--Schemes-On-Surface-Variant, #576066);
  max-width: 275px;
`

const DisplayedGramAndCaloriesPerUnitWrapper = styled(FlexBox)`
  padding: 12px 0px 0px 0px;
  width: 100%;
  gap: 16px;
`

interface IProps {
  calories?: number
  portion: number
  unit: string
  gram: null | number
  alwayDisplayGram?: boolean
}

const DisplayedGramAndCaloriesPerUnit = (props: IProps) => {
  const { calories, portion, unit, gram, alwayDisplayGram } = props

  if (calories === undefined) return null

  const caloriesPerUnit = calories ? calories / portion : 0
  const roundedCaloriesPerUnit = roundByDecimalPlace(caloriesPerUnit, 0)
  const displayedCaloriesPerUnit = formatDisplayNumber(roundedCaloriesPerUnit)
  const calorieUnit = roundedCaloriesPerUnit > 1 ? "calories" : "calorie"

  const roundedGram = gram !== null ? roundByDecimalPlace(gram, 0) : null
  const gramUnit = roundedGram && roundedGram > 1 ? "grams" : "gram"
  const unitConditionToDisplayGram = alwayDisplayGram
    ? true
    : !["grams", "gram"].includes(unit)
  const shouldDisplayGram = gram !== null && unitConditionToDisplayGram

  return (
    <DisplayedGramAndCaloriesPerUnitWrapper $justify="flex-end">
      {shouldDisplayGram && !!roundedGram && (
        <DisplayedCalories>{`${formatDisplayNumber(
          roundedGram,
        )} ${gramUnit}`}</DisplayedCalories>
      )}

      <DisplayedCalories>
        {`${displayedCaloriesPerUnit} ${calorieUnit} / ${unit}`}
      </DisplayedCalories>
    </DisplayedGramAndCaloriesPerUnitWrapper>
  )
}

export default DisplayedGramAndCaloriesPerUnit
